import { i as g, x as m, a as u, c as v } from "../lit-element-8JrrHldg.js";
import { S as b } from "../shoelace-event-controller-BFWPTmUE.js";
import { S as h } from "../chunk.3HB7VQL2-CXyrsj0m.js";
import { L as f } from "../chunk.WLV3FVBR-BO0XtQ7O.js";
import { c as y } from "../chunk.TUVJKY7S-CZwfrQkU.js";
import { a as e, S as z } from "../chunk.UYAO2JRR-CUGf3xdB.js";
import { e as x } from "../class-map-Di-Oe7s4.js";
import { n as s } from "../property-4FoNj0Pi.js";
import "../chunk.E6QAPUBK-CYG-_UAc.js";
var _ = g`
  :host {
    display: inline-block;
  }

  .tag {
    display: flex;
    align-items: center;
    border: solid 1px;
    line-height: 1;
    white-space: nowrap;
    user-select: none;
    -webkit-user-select: none;
  }

  .tag__remove::part(base) {
    color: inherit;
    padding: 0;
  }

  /*
   * Variant modifiers
   */

  .tag--primary {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-200);
    color: var(--sl-color-primary-800);
  }

  .tag--primary:active > sl-icon-button {
    color: var(--sl-color-primary-600);
  }

  .tag--success {
    background-color: var(--sl-color-success-50);
    border-color: var(--sl-color-success-200);
    color: var(--sl-color-success-800);
  }

  .tag--success:active > sl-icon-button {
    color: var(--sl-color-success-600);
  }

  .tag--neutral {
    background-color: var(--sl-color-neutral-50);
    border-color: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-800);
  }

  .tag--neutral:active > sl-icon-button {
    color: var(--sl-color-neutral-600);
  }

  .tag--warning {
    background-color: var(--sl-color-warning-50);
    border-color: var(--sl-color-warning-200);
    color: var(--sl-color-warning-800);
  }

  .tag--warning:active > sl-icon-button {
    color: var(--sl-color-warning-600);
  }

  .tag--danger {
    background-color: var(--sl-color-danger-50);
    border-color: var(--sl-color-danger-200);
    color: var(--sl-color-danger-800);
  }

  .tag--danger:active > sl-icon-button {
    color: var(--sl-color-danger-600);
  }

  /*
   * Size modifiers
   */

  .tag--small {
    font-size: var(--sl-button-font-size-small);
    height: calc(var(--sl-input-height-small) * 0.8);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
    padding: 0 var(--sl-spacing-x-small);
  }

  .tag--medium {
    font-size: var(--sl-button-font-size-medium);
    height: calc(var(--sl-input-height-medium) * 0.8);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
    padding: 0 var(--sl-spacing-small);
  }

  .tag--large {
    font-size: var(--sl-button-font-size-large);
    height: calc(var(--sl-input-height-large) * 0.8);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
    padding: 0 var(--sl-spacing-medium);
  }

  .tag__remove {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /*
   * Pill modifier
   */

  .tag--pill {
    border-radius: var(--sl-border-radius-pill);
  }
`, r = class extends z {
  constructor() {
    super(...arguments), this.localize = new f(this), this.variant = "neutral", this.size = "medium", this.pill = !1, this.removable = !1;
  }
  handleRemoveClick() {
    this.emit("sl-remove");
  }
  render() {
    return m`
      <span
        part="base"
        class=${x({
      tag: !0,
      // Types
      "tag--primary": this.variant === "primary",
      "tag--success": this.variant === "success",
      "tag--neutral": this.variant === "neutral",
      "tag--warning": this.variant === "warning",
      "tag--danger": this.variant === "danger",
      "tag--text": this.variant === "text",
      // Sizes
      "tag--small": this.size === "small",
      "tag--medium": this.size === "medium",
      "tag--large": this.size === "large",
      // Modifiers
      "tag--pill": this.pill,
      "tag--removable": this.removable
    })}
      >
        <slot part="content" class="tag__content"></slot>

        ${this.removable ? m`
              <sl-icon-button
                part="remove-button"
                exportparts="base:remove-button__base"
                name="x-lg"
                library="system"
                label=${this.localize.term("remove")}
                class="tag__remove"
                @click=${this.handleRemoveClick}
                tabindex="-1"
              ></sl-icon-button>
            ` : ""}
      </span>
    `;
  }
};
r.styles = [y, _];
r.dependencies = { "sl-icon-button": h };
e([
  s({ reflect: !0 })
], r.prototype, "variant", 2);
e([
  s({ reflect: !0 })
], r.prototype, "size", 2);
e([
  s({ type: Boolean, reflect: !0 })
], r.prototype, "pill", 2);
e([
  s({ type: Boolean })
], r.prototype, "removable", 2);
var d = r;
r.define("sl-tag");
const w = ":host{--sl-color-primary-50: var(--core-color-blue-200);--sl-color-success-50: var(--core-color-green-200);--sl-color-neutral-50: var(--core-color-monochrome-100);--sl-color-warning-50: var(--core-color-yellow-200);--sl-color-danger-50: var(--core-color-red-200);--sl-button-font-size-medium: var(--core-font-size-12);--sl-button-font-size-small: var(--core-font-size-12);--sl-button-font-size-large: var(--core-font-size-14);--sl-input-border-radius-small: var(--core-radius-4);--sl-input-border-radius-large: var(--core-radius-4);--sl-spacing-medium: var(--core-distance-3);--sl-spacing-small: var(--core-distance-2);--sl-spacing-x-small: 6px}:host::part(base){border:none!important;border-radius:var(--core-radius-4)!important;color:var(--core-color-monochrome-1000)!important;height:fit-content!important;line-height:20px!important;padding-block:2px!important}:host::part(content){display:inline-flex!important;gap:var(--core-distance-1)!important}:host::part(remove-button){font-size:var(--core-font-size-12)!important;margin-inline-start:2px!important}:host sl-icon-button::part(base){border-radius:2px!important;color:var(--core-color-monochrome-600)!important;transition:background .3s ease-in-out,color .3s ease-in-out!important}:host sl-icon-button::part(base):hover,:host sl-icon-button::part(base):focus-visible{color:#16191d!important}:host sl-icon-button::part(base):hover{background-color:#16191d29!important}:host sl-icon-button::part(base):active{background-color:#16191d33!important}:host([variant=text])::part(base){background-color:var(--core-color-monochrome-0)!important;border:1px solid var(--core-color-monochrome-300)!important}:host([variant=text]) sl-icon-button::part(base){border:0!important}:host([removable])::part(base){padding-right:var(--core-distance-1)!important}:host([removable]) sl-icon-button::part(base){padding:2px!important}:host([size=small])::part(base){padding-block:0!important}:host([size=small][removable])::part(base){padding-right:2px!important}:host([size=large])::part(base){padding-block:var(--core-distance-1)!important}:host([size=large]) sl-icon-button::part(base){padding:var(--core-distance-1)!important}";
var k = Object.defineProperty, S = Object.getOwnPropertyDescriptor, C = (p, t, l, a) => {
  for (var o = a > 1 ? void 0 : a ? S(t, l) : t, i = p.length - 1, n; i >= 0; i--)
    (n = p[i]) && (o = (a ? n(t, l, o) : n(o)) || o);
  return a && o && k(t, l, o), o;
};
let c = class extends d {
  constructor() {
    super(), this.pill = !1, new b(this, ["sl-remove"]);
  }
};
c.styles = [d.styles, u(w)];
c = C([
  v("pwc-tag")
], c);
export {
  c as PwcTag
};
